import { createAsyncThunk } from '@reduxjs/toolkit';
import { lexiconService, LexiconTagField } from 'src/services';
import { LexiconTagType } from 'src/services/src/service/lexicon/types';

export const lexiconItemAutoCompleteActions = {
  getAvailableTranslations: createAsyncThunk(
    'LexiconItemAutoComplete/GetAvailableTranslations',
    async (
      {
        shopId,
        locale,
        searchTerm,
        tagField,
        categories,
        attributes,
        values,
        masterTag,
        verticals,
        tagType,
      }: {
        shopId: number;
        locale: string;
        tagType: LexiconTagType;
        searchTerm: string;
        tagField: LexiconTagField;
        categories?: string[];
        attributes?: string[];
        verticals?: string[];
        values?: string[];
        masterTag?: string;
      },
      { rejectWithValue, signal }
    ) => {
      try {
        const { availableValues } = await lexiconService.getAvailableTranslations(
          {
            shopId,
            locale,
            searchTerm,
            tagField,
            categories,
            attributes,
            values,
            masterTag,
            verticals,
            tagType,
          },
          { abortSignal: signal }
        );

        return { availableValues };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
  getAvailableKeys: createAsyncThunk(
    'LexiconItemAutoComplete/GetAvailableKeys',
    async (
      parameters: Parameters<typeof lexiconService.getAvailableKeys>[0],
      { rejectWithValue }
    ) => {
      try {
        const res = await lexiconService.getAvailableKeys(parameters);
        return res;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
  ),
  getAvailableVerticals: createAsyncThunk(
    'LexiconItemAutoComplete/GetAvailableVerticals',
    async (
      parameters: Parameters<typeof lexiconService.getAvailableVerticals>[0],
      { rejectWithValue }
    ) => {
      try {
        const res = await lexiconService.getAvailableVerticals(parameters);
        return res;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
  ),
};
